$(function () {
    // TODO: https://www.cookieyes.com/documentation/events-on-cookie-banner-interactions/
    console.log("Adding CookieYes consent update event handler.");
    document.addEventListener("cookieyes_consent_update", function (eventData) {
        console.log("CookieYes consent update event handler.");
        console.log(eventData);
        var data = eventData.detail;
        console.log(data);
        if (data.accepted.includes("analytics")) {
            // perform desired action.
        }
    });
});